import { z } from "zod"

export const projectsFilterFormDataSchema = z.object({
  projectPhase: z.array(z.string()).nullish(),
  searchTerm: z.string().nullish(),
  sort: z.string().nullish()
})

export type ProjectsFilterFormData = z.infer<
  typeof projectsFilterFormDataSchema
>
